import { create } from 'zustand';

import { SignsOrderProperty } from '@/modules/api';
import { SignsTableMode, SignsTableState } from '@/types/SignsTableState';

export const useSignsTableStore = create<SignsTableState>()((set) => ({
  mode: SignsTableMode.TABLE_AND_MAP,

  globalFilter: '',
  includeAdditional: false,
  columnFilters: [{ id: 'status', value: ['PLACED', 'DRAFT'] }],
  sorting: [{ id: SignsOrderProperty.createdAt.toString(), desc: true }],

  actions: {
    setMode: (mode) => set({ mode }),
    expandModeMap: () =>
      set(({ mode }) => ({
        mode: Object.values(SignsTableMode)[Math.max(Object.values(SignsTableMode).indexOf(mode) - 1, 0)],
      })),
    expandModeTable: () =>
      set(({ mode }) => ({
        mode: Object.values(SignsTableMode)[Math.min(Object.values(SignsTableMode).indexOf(mode) + 1, 2)],
      })),

    setGlobalFilter: (globalFilter) => set({ globalFilter }),
    setIncludeAdditional: (includeAdditional) => set({ includeAdditional }),
    setColumnFilters: (updaterOrValue) =>
      set(({ columnFilters }) => ({
        columnFilters: typeof updaterOrValue === 'function' ? updaterOrValue(columnFilters) : updaterOrValue,
      })),
    setSorting: (sorting) => set({ sorting }),
  },
}));
